import { mutate as globalMutate } from 'swr';

/**
 * Revalidate every SWR cache key that points at the transactions list endpoint.
 * Use after creating, updating, or deleting a transaction so the LSGD list
 * and any other open transactions list refresh without manual pull-to-refresh.
 *
 * Matches both plain useSWR keys ('/transactions?...') and the SWR Infinite
 * tracker keys ('$inf$"/transactions?..."') by substring.
 */
export const revalidateTransactionsList = () =>
  globalMutate(
    (key: unknown) => typeof key === 'string' && key.includes('/transactions'),
    undefined,
    { revalidate: true },
  );
